import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import "./VoiceInputs.css";

const VoiceInputs = () => {
    const [text, setText] = useState("");
    const [listening, setListening] = useState(false);
    const recognitionRef = useRef(null);

    useEffect(() => {
        // Initialize speech recognition
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            console.error("Speech Recognition not supported in this browser");
            return;
        }

        recognitionRef.current = new SpeechRecognition();
        recognitionRef.current.continuous = true;
        recognitionRef.current.interimResults = true;
        recognitionRef.current.lang = "en-US";

        recognitionRef.current.onresult = (event) => {
            let interimTranscript = "";
            let finalTranscript = text;

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const transcript = event.results[i][0].transcript;
                if (event.results[i].isFinal) {
                    finalTranscript += transcript + " ";
                } else {
                    interimTranscript += transcript;
                }
            }

            setText(finalTranscript + interimTranscript);
        };

        recognitionRef.current.onerror = (event) => {
            console.error("Speech recognition error:", event.error);
            stopListening();
        };

        recognitionRef.current.onend = () => {
            setListening(false);
        };

        return () => {
            if (recognitionRef.current) {
                recognitionRef.current.stop();
            }
        };
    }, [text]);

    const startListening = () => {
        if (recognitionRef.current) {
            try {
                recognitionRef.current.start();
                setListening(true);
            } catch (error) {
                console.error("Error starting speech recognition:", error);
                setListening(false);
            }
        }
    };

    const stopListening = () => {
        if (recognitionRef.current) {
            recognitionRef.current.stop();
            setListening(false);
        }
    };

    const clearText = () => {
        setText("");
    };

    return (
        <Container className="voice-input-container">
            <div className="form-group">
                <label className="title">🎤 React Voice Input</label>
                <textarea
                    className="form-control voice-textarea"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Speak something or type here..."
                    rows="5"
                />
                <div className="button-group">
                    {!listening ? (
                        <button className="btn btn-start" onClick={startListening}>
                            Start Listening
                        </button>
                    ) : (
                        <button className="btn btn-stop" onClick={stopListening}>
                            Stop Listening
                        </button>
                    )}
                    <button className="btn btn-clear" onClick={clearText}>
                        Clear Text
                    </button>
                </div>
                <div className="status">
                    Status: {listening ?
                        <span className="listening">Listening... <div className="pulse"></div></span> :
                        <span className="not-listening">Not Listening</span>}
                </div>
            </div>
        </Container>
    );
};

export default VoiceInputs;